<template>
    <div class="customers-info-section">
        <div class="row">
            <div class="col-md-9"></div>
            <div class="col-md-3" v-if="hasScopes('export-customer-profile')">
                <button
                    :class="[
                        'btn btn-primary',
                        { disabled: loading },
                    ]"
                    :disabled="loading || disabled"
                    type="button"
                    @click="checkConfig()"
                >
                    <span class="btn-text">Download Profile</span>
                    <span class="loader"></span>
                </button>
            </div>
        </div>
        <div class="col-md-3 mt-custom-44"></div>
        <div class="row">
            <div class="col-md-3 col-sm-12 text-center profile-image-section">
                <div
                    v-if="
                        customerDetails.pictureURL != null &&
                        customerDetails.pictureURL != 'customers/no-preview.png'
                    "
                    class="customer-profile"
                >
                    <img v-authenticated-image="customerDetails.pictureURL" />
                </div>
                <div v-else class="customer-profile">
                    <img
                        v-authenticated-image="`/users/blank-profile-pic.png`"
                        alt="blank profile image"
                    />
                </div>

                <base-status
                    v-if="customerDetails.status"
                    :status-type="customerDetails.status"
                ></base-status>
            </div>

            <div class="col-md-9 col-sm-12">
                <ul>
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3 v-if="customerDetails.type=='company'">Company Information</h3>
                                    <h3 v-else>Customer Information</h3>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Idenfo ID:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.idenfoId
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label v-if="customerDetails.type=='company'">Company Name:</label>
                                            <label v-else>Full Name:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span :class="{'uaePassed': customerDetails.uaePassDetails && customerDetails.uaePassDetails.fullnameEN}" >{{ fullName }} </span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6" v-if="customerDetails.type!='company' && customerDetails.fatherName">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Father Name:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails.fatherName
                                                "
                                                class=""
                                                >{{
                                                    customerDetails.fatherName
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6" v-if="customerDetails.type!='company'">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Gender:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span :class="{'uaePassed': customerDetails.uaePassDetails && (customerDetails.uaePassDetails.gender=='Male' || customerDetails.uaePassDetails.gender=='Female')}">{{
                                                customerDetails.gender
                                                    ? customerDetails.gender
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label v-if="customerDetails.type=='company'">Date of Incorporation :</label>
                                            <label v-else>Date of Birth:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="" v-if="customerDetails.dateOfBirth">
                                                        {{
                                                            customerDetails.dateOfBirth | moment('D MMM, YYYY')

                                                    }}</span>
                                            <span v-else>
                                                       N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label v-if="customerDetails.type=='company'">Country of Domicile:</label>
                                            <label v-else>Country of Residence:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                :class="{
                                                    danger: customerDetails.countryOfResidenceIsSanction,
                                                }"
                                                >{{
                                                    customerDetails.countryOfResidence
                                                        ? customerDetails
                                                              .countryOfResidence
                                                        : 'N/A'
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label v-if="customerDetails.type=='company'">Country of Operation:</label>
                                            <label v-else>Nationality:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                :class="{
                                                    danger: customerDetails.nationalityIsSanction,
                                                    'uaePassed': customerDetails.uaePassDetails && customerDetails.uaePassDetails.nationalityEN
                                                }"
                                                >{{
                                                    customerDetails.nationality
                                                        ? customerDetails
                                                              .nationality
                                                        : 'N/A'
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6" v-if="customerDetails.otherNationalities && customerDetails.otherNationalities.length>0">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label v-if="customerDetails.type=='company'">Other Countries:</label>
                                            <label v-else>Other Nationalities:</label>
                                        </li>
                                        <li v-for="(nationality, index) in customerDetails.otherNationalities"
                                            :key="index">
  <span :class="{ danger: nationality.isSanction }">
    {{ nationality ? nationality + (index < customerDetails.otherNationalities.length - 1 ? ', ' : '') : '' }}
  </span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Is CRS:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span>{{
                                                customerDetails.isCRS
                                                    ? 'Yes'
                                                    : 'No'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6" v-if="customerDetails.type!='company'">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Resident Status:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                            customerDetails
                                                                .profileType
                                                                ? customerDetails
                                                                    .profileType
                                                                : 'N/A'
                                                    }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6" v-if="customerDetails.type=='company'">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Company Relationship:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                            customerDetails
                                                                .companyRelationship
                                                                ? customerDetails
                                                                    .companyRelationship
                                                                : 'N/A'
                                                    }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label v-if="customerDetails.type=='company' && tempCountry=='UK'">Company Registration Number:</label>
                                            <label v-else-if="customerDetails.type=='company' && tempCountry=='PK'">NTN Number / Registration Number:</label>
                                            <label v-else-if="customerDetails.type=='company'">Company Registration / Trade License Number:</label>
                                            <label v-else>{{"National ID Card Number"}}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span :class="{'uaePassed': customerDetails.uaePassDetails && customerDetails.uaePassDetails.idn}">{{
                                                customerDetails.identityInfo && customerDetails.identityInfo
                                                    .number ?  customerDetails.identityInfo
                                                    .number : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6" v-if="customerDetails.type=='company' && tempCountry!='PK'">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label v-if="customerDetails.type=='company' && tempCountry=='UK'">Company Registration Expiry:</label>
                                            <label v-else-if="customerDetails.type=='company'">Company Registration / Trade License Expiry:</label>
                                            <label v-else>{{"National ID Expiry"}}</label>

                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="
                                                   customerDetails.identityInfo && customerDetails.identityInfo.expiryDate
                                                "
                                                    :class="
                                                    addDangerClass(
                                                        customerDetails
                                                            .identityInfo
                                                            .expiryDate
                                                    )
                                                "
                                            >{{
                                                    customerDetails.identityInfo
                                                        .expiryDate
                                                        | moment('D MMM, YYYY')
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div v-if="customerDetails.identityInfo && customerDetails.identityInfo.passport" class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label v-if="customerDetails.type=='company' && tempCountry=='PK'">CUIN Number / Registration Number:</label>
                                            <label v-else-if="customerDetails.type!='company'">Passport Number:</label>
                                        </li>
                                        <li class="col-md-6">
                                                    <span class="">{{
                                                            customerDetails
                                                                .identityInfo
                                                                .passport.number
                                                                ? customerDetails
                                                                    .identityInfo
                                                                    .passport.number
                                                                : 'N/A'
                                                    }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div v-if="country!='Pakistan' && customerDetails.type!='company' && customerDetails.identityInfo && customerDetails.identityInfo.passport" class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Passport Number Expiry:</label>
                                        </li>
                                        <li class="col-md-6">
                                                    <span :class="addDangerClass(
                                                        customerDetails
                                                            .identityInfo
                                                            .passport
                                                            .expiryDate
                                                    )" v-if="customerDetails.identityInfo.passport.expiryDate">
                                                        {{
                                                            customerDetails
                                                                    .identityInfo.passport
                                                                    .expiryDate | moment('D MMM, YYYY')

                                                    }}</span>
                                            <span v-else>
                                                       N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Onboarded By:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="
                                                    customerDetails.userName
                                                "
                                                    class=""
                                            >{{
                                                    customerDetails.userName
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Record Last Updated:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="customerDetails.updatedAt"
                                            >{{
                                                    customerDetails.updatedAt
                                                        | moment('D MMM, YYYY')
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div v-if="customerDetails.parentCompanies && customerDetails.parentCompanies.length" class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label v-if="customerDetails.parentCompanies.length>1">Associated Companies:</label>
                                            <label v-else>Associated Company:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <ol v-if="customerDetails.parentCompanies.length>1" style="padding: 0;">
                                                <li v-for="parentCompany in customerDetails.parentCompanies">
                                                    <router-link
                                                        target="_blank" 
                                                        :to="{
                                                            name: 'company-information',
                                                            params: {
                                                                id: parentCompany._id,
                                                            },
                                                        }">
                                                        {{ parentCompany.title || parentCompany.basicInfo.firstName }}
                                                    </router-link>
                                                </li>
                                            </ol>
                                            <span v-else>
                                                <router-link
                                                        target="_blank" 
                                                        :to="{
                                                            name: 'company-information',
                                                            params: {
                                                                id: customerDetails.parentCompanies[0]._id,
                                                            },
                                                        }">
                                                        {{ customerDetails.parentCompanies[0].title || customerDetails.parentCompanies[0].basicInfo.firstName }}
                                                    </router-link>
                                            </span>
                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-if="customerDetails.contactInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Contact Information</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Address:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.contactInfo
                                                    .address
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label v-if="tempCountry=='UK'">Town:</label>
                                            <label v-else>City:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.contactInfo.city
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label v-if="tempCountry=='UK'">County:</label>
                                            <label v-else>State:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails.contactInfo &&
                                                    customerDetails.contactInfo
                                                        .state && customerDetails.contactInfo
                                                        .state.length > 0
                                                "
                                                class=""
                                                >{{
                                                checkState(customerDetails.contactInfo
                                                        .state)

                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label v-if="tempCountry=='UK'">Postal Code:</label>
                                            <label v-else>Zip/Postal Code:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.contactInfo ? customerDetails.contactInfo
                                                    .postalCode : ""
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Contact Number:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                :class="{
                                                    danger: customerDetails
                                                        .contactInfo
                                                        .isdCodeIsSanction,
                                                        'uaePassed': customerDetails.uaePassDetails && customerDetails.uaePassDetails.mobile
                                                }"
                                                >{{
                                                    customerDetails.contactInfo
                                                        .isdCode
                                                }}
                                                {{
                                                    customerDetails.contactInfo
                                                        .phoneNumber
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Email Address:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.contactInfo
                                                    .email
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6"  v-if="customerDetails.isSelfServiceRegistration === false">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>IP Address:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <a @click="showPopup('ip-popup')" v-if="customerDetails.ipLocationDetails && customerDetails.ipLocationDetails.ip" class="link link-primary">{{
                                                customerDetails.ipLocationDetails.ip
                                            }}</a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6" v-if="customerDetails.ipLocationDetails && customerDetails.ipLocationDetails.city">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label v-if="tempCountry=='UK'">IP Derived Town:</label>
                                            <label v-else>IP Derived City:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span :class="{
                                                'text-danger': customerDetails.ipLocationDetails && customerDetails.ipLocationDetails.city && customerDetails.contactInfo.city && customerDetails.contactInfo.city != customerDetails.ipLocationDetails.city
                                            }">{{
                                                customerDetails.ipLocationDetails && customerDetails.ipLocationDetails.city ? customerDetails.ipLocationDetails.city  : ""
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-if="customerDetails.occupationInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12"><h3>Profile Information</h3></div>
                                <div class="col-md-6" v-if="customerDetails.type!='company'">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Work Type:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails
                                                        .occupationInfo.workType
                                                        .length > 0
                                                "
                                                class=""
                                                >{{
                                                    customerDetails
                                                        .occupationInfo
                                                        .workType[0].title
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Industry:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails
                                                        .occupationInfo.industry
                                                        .length
                                                "
                                                class=""
                                                >{{
                                                    customerDetails
                                                        .occupationInfo
                                                        .industry[0].title
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Products:</label>
                                        </li>
                                        <li class="col-md-6">
                                                            <span class="" v-if="customerDetails.accountInfo.products && customerDetails.accountInfo.products.length">{{
                                                                customerDetails.accountInfo.products
                                                                    .map((e) => e.title)
                                                                    .join(', ')
                                                            }}</span>
                                            <span v-else>
                                                N/A
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Product Offered:</label>
                                        </li>
                                        <li class="col-md-6">
                                                            <span class="" v-if="customerDetails.accountInfo.productOffered">{{
                                                                customerDetails.accountInfo.productOffered}}
                                                            </span>
                                            <span v-else>
                                                N/A
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Delivery Channel:</label>
                                        </li>
                                        <li class="col-md-6">
                                                                            <span
                                                                                    v-if="
                                                                                    customerDetails.accountInfo
                                                                                        .registrationChannel &&
                                                                                        customerDetails
                                                                                            .accountInfo
                                                                                            .registrationChannel
                                                                                            .length
                                                                                "
                                                                                    class=""
                                                                            >{{
                                                                                    customerDetails.accountInfo
                                                                                        .registrationChannel[0]
                                                                                        .title
                                                                                }}</span
                                                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6" v-if="customerDetails.type!='company' && customerDetails.occupationInfo.taxId">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Tax ID:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails
                                                        .occupationInfo.taxId
                                                "
                                                class=""
                                                >{{
                                                    customerDetails
                                                        .occupationInfo.taxId
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    v-if="country != 'Pakistan' && customerDetails.type!='company' && customerDetails.occupationInfo.tradeLicenseNumber"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Trade License Number:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails
                                                        .occupationInfo
                                                        .tradeLicenseNumber
                                                "
                                                class=""
                                                >{{
                                                    customerDetails
                                                        .occupationInfo
                                                        .tradeLicenseNumber
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div v-if="country!='Pakistan' && customerDetails.type!='company' && customerDetails.occupationInfo.tradeLicenseExpiryDate" class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Trade License Expiry:</label>
                                        </li>
                                        <li class="col-md-6">
                                                    <span class="">{{
                                                            customerDetails
                                                                .occupationInfo
                                                                .tradeLicenseExpiryDate
                                                                ? customerDetails
                                                                    .occupationInfo
                                                                    .tradeLicenseExpiryDate
                                                                : 'N/A'
                                                    }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div v-if="country!='Pakistan' && customerDetails.type!='company' && customerDetails.occupationInfo.tradeLicenseIncorporationLocation" class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Incorporation Location:</label>
                                        </li>
                                        <li class="col-md-6">
                                                    <span class="">{{
                                                            customerDetails
                                                                .occupationInfo
                                                                .tradeLicenseIncorporationLocation
                                                                ? customerDetails
                                                                    .occupationInfo
                                                                    .tradeLicenseIncorporationLocation
                                                                : 'N/A'
                                                    }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div v-if="customerDetails.type!='company'" class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Company Name:</label>
                                        </li>
                                        <li class="col-md-6">
                                                    <span class="">{{
                                                            customerDetails
                                                                .occupationInfo
                                                                .companyName
                                                                ? customerDetails
                                                                    .occupationInfo
                                                                    .companyName
                                                                : 'N/A'
                                                    }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6"  v-if="customerDetails.type!='company'">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Positions In Company:</label>
                                        </li>
                                        <li class="col-md-6" v-if="customerDetails.occupationInfo.positionsInCompany && customerDetails.occupationInfo.positionsInCompany.length">
                                            <ul class="col-md-12">
                                                <li v-for="(position, index) in customerDetails.occupationInfo.positionsInCompany"
                                                        :key="index">
                                                        <span>
                                                            {{ position ? position.text : 'N/A' }}
                                                            {{ index < customerDetails.occupationInfo.positionsInCompany.length - 1 ? ',' : '' }}
                                                        </span>
                                                    </li>
                                                 </ul>
                                       </li>
                                       <li class="col-md-6" v-else>
                                            <span>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Relationship Start Date:</label>
                                        </li>
                                        <li class="col-md-6">
                                                    <span v-if="customerDetails
                                                                .occupationInfo
                                                                .relationshipStartDate">{{
                                                            
                                                                customerDetails
                                                                    .occupationInfo
                                                                    .relationshipStartDate | moment('D MMM, YYYY')
                                        
                                                    }}</span>
                                                     <span v-else>
                                                        N/A</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-if="customerDetails.accountInfo && customerDetails.accountInfo.isStr">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12"><h3>STR Information</h3></div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>STR Filed:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="
                                                    customerDetails
                                                        .accountInfo.isStr
                                                "
                                                    class=""
                                            >{{
                                                    customerDetails
                                                        .accountInfo
                                                        .isStr.toUpperCase()
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Date of STR:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="
                                                    customerDetails
                                                        .accountInfo.strDate

                                                "
                                                    class=""
                                            >{{
                                                    customerDetails
                                                        .accountInfo
                                                        .strDate | moment('D MMM, YYYY')
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Reason for STR:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="
                                                    customerDetails
                                                        .accountInfo.strReason

                                                "
                                                    class=""
                                            >{{
                                                    customerDetails
                                                        .accountInfo
                                                        .strReason
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-if="customerDetails.accountInfo && customerDetails.accountInfo.isf2f">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12"><h3>Face to Face Declaration</h3></div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Customer Met Face-To-Face?</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="
                                                    customerDetails
                                                        .accountInfo.isf2f
                                                "
                                                    class=""
                                            >{{
                                                    customerDetails
                                                        .accountInfo
                                                        .isf2f.toUpperCase()
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>


                <ul v-if="customerDetails.pepDeclaration && customerDetails.type!='company'">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>PEP Declaration</h3>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >DO YOU CURRENTLY HOLD ANY
                                                PUBLIC POSITION?</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.pepDeclaration
                                                    .anyPublicPos
                                                    ? customerDetails
                                                          .pepDeclaration
                                                          .anyPublicPos
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >DID YOU HOLD ANY PUBLIC
                                                POSITION IN THE LAST 12
                                                MONTHS?</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.pepDeclaration
                                                    .posLastTwoMonths
                                                    ? customerDetails
                                                          .pepDeclaration
                                                          .posLastTwoMonths
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >HAVE YOU EVER HELD ANY PUBLIC
                                                POSITION?</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.pepDeclaration
                                                    .everPublicPosition
                                                    ? customerDetails
                                                          .pepDeclaration
                                                          .everPublicPosition
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >DO YOU HAVE OR HAVE YOU EVER
                                                HAD ANY DIPLOMATIC
                                                IMMUNITY?</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.pepDeclaration
                                                    .diplomaticImmunity
                                                    ? customerDetails
                                                          .pepDeclaration
                                                          .diplomaticImmunity
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >DO YOU HAVE A RELATIVE WHO HAS
                                                HELD PUBLIC POSITION IN THE LAST
                                                12 MONTHS?</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.pepDeclaration
                                                    .relativeTwelveMonths
                                                    ? customerDetails
                                                          .pepDeclaration
                                                          .relativeTwelveMonths
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >DO YOU HAVE A CLOSE ASSOCIATE
                                                WHO HAS HELD PUBLIC POSITION IN
                                                THE LAST 12 MONTHS?</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.pepDeclaration
                                                    .closeAssociateTwelveMonths
                                                    ? customerDetails
                                                          .pepDeclaration
                                                          .closeAssociateTwelveMonths
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >HAS THERE BEEN A CONVICTION
                                                AGAINST YOU BY A COURT OF
                                                LAW?</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.pepDeclaration
                                                    .conviction
                                                    ? customerDetails
                                                          .pepDeclaration
                                                          .conviction
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >IF YOU HAVE ANSWERED “YES” TO
                                                ANY OF THE QUESTIONS,
                                                DETAILS:</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.pepDeclaration
                                                    .other
                                                    ? customerDetails
                                                          .pepDeclaration.other
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-if="customerDetails.sourceOfWealth && customerDetails.type!='company'">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Source Of Wealth</h3>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>SOURCE OF WEALTH</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-for="(
                                                    item, index
                                                ) in customerDetails
                                                    .sourceOfWealth.evidenced"
                                                :key="index"
                                            >
                                                {{ item }}
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Other</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.sourceOfWealth
                                                    .OtherEvidenced
                                                    ? customerDetails
                                                          .sourceOfWealth
                                                          .OtherEvidenced
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-if="customerDetails.sourceOfFunds">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Source Of Funds</h3>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6" v-if="customerDetails.type!='company'">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>SOURCE OF FUNDS</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-for="(
                                                    item, index
                                                ) in customerDetails
                                                    .sourceOfFunds.evidenced"
                                                :key="index"
                                            >
                                                {{ item }}
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label v-if="customerDetails.type=='company'">Company's source of fund Information</label>
                                            <label v-else>Other</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.sourceOfFunds
                                                    .OtherEvidenced
                                                    ? customerDetails
                                                          .sourceOfFunds
                                                          .OtherEvidenced
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-if="customerDetails.accountInfo && customerDetails.accountInfo.enhancedDueDiligence">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12"><h3>Enhanced Due Diligence</h3></div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>
                                                DATE OF EDD
                                            </label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .dateOfEdd
                                                "
                                                    class=""
                                            >{{
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .dateOfEdd | moment('D MMM, YYYY')
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>
                                                SCRUTINY PERFORMED OF CUSTOMER IDENTITY USING RELIABLE SOURCES FOR NAME AND ADDRESS
                                            </label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .isScrutinyPerformed
                                                "
                                                    class=""
                                            >{{
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .isScrutinyPerformed
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>
                                                SCRUTINY REMARKS
                                            </label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .scrutinyRemarks
                                                "
                                                    class=""
                                            >{{
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .scrutinyRemarks
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>
                                                DETAILED ENQUIRIES MADE ABOUT THE CUSTOMERS NATURE OF BUSINESS
                                            </label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .isCustBusInquired
                                                "
                                                    class=""
                                            >{{
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .isCustBusInquired
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>
                                                CUSTOMER INQUIRY REMARKS
                                            </label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .custBusInquiredRemarks
                                                "
                                                    class=""
                                            >{{
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .custBusInquiredRemarks
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>
                                                MANAGEMENT APPROVAL HAS BEEN TAKEN
                                            </label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .isManagementApproval

                                                "
                                                    class=""
                                            >{{
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .isManagementApproval
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>
                                                MANAGEMENT APPROVAL REMARKS
                                            </label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .managementApprovalRemarks
                                                "
                                                    class=""
                                            >{{
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .managementApprovalRemarks
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>
                                                CONFIRMATION THAT FIRST PAYMENT HAS BEEN CORRECTLY MADE
                                            </label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .isFirstPayment
                                                "
                                                    class=""
                                            >{{
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .isFirstPayment
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>
                                                FIRST PAYMENT REMARKS
                                            </label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .firstPaymentRemarks
                                                "
                                                    class=""
                                            >{{
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .firstPaymentRemarks
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>
                                                Income last financial year?
                                            </label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .lastFinancialYearIncome
                                                "
                                                    class=""
                                            >{{
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .lastFinancialYearIncome
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>
                                                Assets held by the customer?
                                            </label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                    v-if="
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .shares
                                                "
                                                    class=""
                                            >{{
                                                    customerDetails
                                                        .accountInfo
                                                        .enhancedDueDiligence
                                                        .shares
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-if="customerDetails.type=='company' && customerDetails.dynamicInputValues">
                    <li v-for="(individualTypTitle, individualTypeKey) in associatedIndividualTypes" :key="individualTypeKey">
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>{{ individualTypTitle }}</h3>
                                </div>
                            </div>
                            <div  v-if="customerDetails.dynamicInputValues && customerDetails.dynamicInputValues[individualTypeKey] && customerDetails.dynamicInputValues[individualTypeKey].length > 0">
                                <b-table class="associated-individuals-table" responsive striped hover :items="customerDetails.dynamicInputValues[individualTypeKey]" :fields="individualTypeKey == 'companyShareholders'? associatedShareHolderFields : associatedIndividualFields">
                                    <template slot="name" slot-scope="data">
                                        <span>
                                            <router-link v-if="data.item.customerId && data.item.onboard" 
                                                target="_blank"
                                                :to="{
                                                    name: data.item.entityType == 'company' ? 'company-information' : 'customer-information',
                                                    params: {
                                                        id: data.item.customerId,
                                                    },
                                                }">
                                                {{data.item.name}}
                                            </router-link>
                                            <template v-else> {{ data.item.name }} </template>
                                        </span>
                                    </template>
                                    <template slot="dob" slot-scope="data">
                                        <span>{{
                                                data.item.dob
                                                | moment('MMMM Do YYYY')
                                        }}</span>
                                    </template>
                                    <template slot="dateOfAppointment" slot-scope="data">
                                        <span>{{
                                                data.item.dateOfAppointment
                                                | moment('MMMM Do YYYY')
                                        }}</span>
                                    </template>
                                    <template slot="dateOfTermination" slot-scope="data">
                                        <span>{{
                                                data.item.dateOfTermination
                                                | moment('MMMM Do YYYY')
                                        }}</span>
                                    </template>
                                    <template slot="idExpiry" slot-scope="data">
                                        <span>{{
                                                data.item.idExpiry
                                                | moment('MMMM Do YYYY')
                                        }}</span>
                                    </template>
                                    <template slot="passportExpiry" slot-scope="data">
                                        <span>{{
                                                data.item.passportExpiry
                                                | moment('MMMM Do YYYY')
                                        }}</span>
                                    </template>
                                    <template slot="status" slot-scope="data">
                                        <base-status :status-type="data.item.customerId && data.item.onboard  ? data.item.status : 'not-applicable'"></base-status>
                                    </template>
                                    <template slot="riskRating" slot-scope="data">
                                        <base-status :status-type="data.item.customerId && data.item.onboard  ? data.item.riskRating : 'not-applicable'"></base-status>
                                    </template>
                                </b-table>
                            </div>
                            <div class="row" v-else>
                                <div class="col-md-12">
                                    <em>No value selected</em>
                                </div>
                            </div>
                        </div>
                    </li>
                    

                </ul>
                <ul v-if="customerDetails.type!='company' && customerDetails.dynamicInputValues">
                    <li v-if="customerDetails.dynamicInputValues.thirdPartyDetails">
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Third Party Details</h3>
                                </div>
                            </div>
                            <div class="row" v-if="customerDetails.dynamicInputValues && customerDetails.dynamicInputValues.thirdPartyDetails && customerDetails.dynamicInputValues.thirdPartyDetails.length > 0">
                                <div class="col-md-4">
                                    <ul class="row"  v-for="(
                                                    item, index
                                                ) in customerDetails
                                                    .dynamicInputValues.thirdPartyDetails"
                                        :key="index">
                                        <li class="col-md-6">
                                            <label>Name</label>
                                        </li>
                                        <li class="col-md-6">
                                            {{ item.fullName }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-4">
                                    <ul class="row"  v-for="(
                                                    item, index
                                                ) in customerDetails
                                                    .dynamicInputValues.thirdPartyDetails"
                                        :key="index">
                                        <li class="col-md-6">
                                            <label>Type</label>
                                        </li>
                                        <li class="col-md-6">
                                            {{ item.type }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-4">
                                    <ul class="row"  v-for="(
                                                    item, index
                                                ) in customerDetails
                                                    .dynamicInputValues.thirdPartyDetails"
                                        :key="index">
                                        <li class="col-md-6">
                                            <label>National ID Number</label>
                                        </li>
                                        <li class="col-md-6">
                                            {{ item.nationalIdNumber }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row" v-else>
                                <div class="col-md-12">
                                    <em>No value selected</em>
                                </div>
                            </div>
                        </div>
                    </li>

                </ul>
                <ul v-if="customerDetails.type!='company' && customerDetails.jointAccountInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Joint Account Info</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Is Joint Account:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.jointAccountInfo.isJointAccount)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Name of Joint Account Holder:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                               formatValue(customerDetails.jointAccountInfo.name)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Relationship with Customer:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.jointAccountInfo.relation)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Joint Act Holder National ID No:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.jointAccountInfo.idNumber)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Email Address:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                               formatValue(customerDetails.jointAccountInfo.email)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Mailing Address:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.jointAccountInfo.address)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Phone Number:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">
                                                {{formatValue(customerDetails.jointAccountInfo.isdCode)}}
                                                {{
                                                formatValue(customerDetails.jointAccountInfo.phoneNumber)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-if="customerDetails.type!='company' && customerDetails.minorAccountInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Minor Account Info</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Is Minor Account:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.minorAccountInfo.isMinorAccount)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Name of Guardian:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                               formatValue(customerDetails.minorAccountInfo.name)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Relationship with Minor:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.minorAccountInfo.relation)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Guardian National ID No:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.minorAccountInfo.idNumber)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Guardian Email Address:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                               formatValue(customerDetails.minorAccountInfo.email)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Guardian Address:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.minorAccountInfo.address)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Guardian Phone Number:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">
                                                {{formatValue(customerDetails.minorAccountInfo.isdCode)}}
                                                {{
                                                formatValue(customerDetails.minorAccountInfo.phoneNumber)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-if="customerDetails.type!='company' && customerDetails.fatcaInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>FATCA Info</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Full Name:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.fatcaInfo.name)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>National ID Number:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                               formatValue(customerDetails.fatcaInfo.idNumber)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Place Of Birth:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.fatcaInfo.placeOfBirth)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>HAVE YOU GIVEN ANY POWER OF ATTORNEY TO ANY OVERSEA'S RESIDENT?:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.fatcaInfo.isPowerAttorney)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>POWER OF ATTORNEY’S NAME:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.fatcaInfo.powerAttorneyName)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>POWER OF ATTORNEY’S ADDRESS:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                               formatValue(customerDetails.fatcaInfo.powerAttorneyAddress)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>ARE YOU A RESIDENT OF ANY OVERSEAS COUNTRY?:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.fatcaInfo.hasOtherResidency)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6" v-if="customerDetails.fatcaInfo.otherResidency && customerDetails.fatcaInfo.otherResidency.length>0">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>COUNTRY OF OVERSEAS RESIDENCE:</label>
                                        </li>
                                        <li v-for="(otherResidency, index) in customerDetails.fatcaInfo.otherResidency"
                                            :key="index">
                                             <span :class="{ danger: otherResidency.isSanction }">
                                               {{formatValue( otherResidency.title ? otherResidency.title + (index < customerDetails.fatcaInfo.otherResidency.length - 1 ? ', ' : '') : '' )}}
                                             </span>
                                        </li>
                                    </ul>
                                </div>
                        
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>DO YOU HAVE ANY OVERSEAS TAX OBLIGATIONS?:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.fatcaInfo.isCountryTax)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6" v-if="customerDetails.fatcaInfo.taxCountries && customerDetails.fatcaInfo.taxCountries.length>0">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>COUNTRY OF OVERSEAS TAX OBLIGATION:</label>
                                        </li>
                                        <li v-for="(taxCountry, index) in customerDetails.fatcaInfo.taxCountries"
                                            :key="index">
                                             <span :class="{ danger: taxCountry.isSanction }">
                                               {{ formatValue(taxCountry.title ? taxCountry.title + (index < customerDetails.fatcaInfo.taxCountries.length - 1 ? ', ' : '') : '') }}
                                             </span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6" v-if="customerDetails.fatcaInfo.nationalities && customerDetails.fatcaInfo.nationalities.length>0">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>NATIONALITY / NATIONALITIES:</label>
                                        </li>
                                        <li v-for="(nationality, index) in customerDetails.fatcaInfo.nationalities"
                                            :key="index">
                                             <span :class="{ danger: nationality.isSanction }">
                                               {{ formatValue(nationality.title ? nationality.title + (index < customerDetails.fatcaInfo.nationalities.length - 1 ? ', ' : '') : '' )}}
                                             </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-if="customerDetails.type!='company' && customerDetails.crsInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>CRS Info</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>COUNTRY OF TAX RESIDENCE #1:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.crsInfo.countryTax1)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>TIN OR EQUIVALENT #1:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                               formatValue(customerDetails.crsInfo.tin1)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>REASON #1:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.crsInfo.reason1)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>COUNTRY OF TAX RESIDENCE #2:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.crsInfo.countryTax2)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>TIN OR EQUIVALENT #2:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.crsInfo.tin2)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>REASON #2:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                               formatValue(customerDetails.crsInfo.reason2)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>COUNTRY OF TAX RESIDENCE #3:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.crsInfo.countryTax3)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>TIN OR EQUIVALENT #2:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                               formatValue(customerDetails.crsInfo.tin3)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                        
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>REASON #3:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.crsInfo.reason3)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>IF REASON B SELECTED, PLEASE EXPLAIN WHY YOU ARE UNABLE TO OBTAIN A TIN OR FUNCTIONAL EQUIVALENT #1:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.crsInfo.otherReason1)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>IF REASON B SELECTED, PLEASE EXPLAIN WHY YOU ARE UNABLE TO OBTAIN A TIN OR FUNCTIONAL EQUIVALENT #2:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.crsInfo.otherReason2)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>IF REASON B SELECTED, PLEASE EXPLAIN WHY YOU ARE UNABLE TO OBTAIN A TIN OR FUNCTIONAL EQUIVALENT #3:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.crsInfo.otherReason3)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-if="customerDetails.type!='company' && customerDetails.additionalInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Investment Range:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.additionalInfo.investment)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6" v-if="customerDetails.additionalInfo.gccNational">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>GCC National:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                               formatValue(customerDetails.additionalInfo.gccNational)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li v-if="customerDetails.additionalInfo.accountManager">
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Account Manager</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Full Name:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                formatValue(customerDetails.additionalInfo.accountManager.name)
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>

                <ul v-if="customerDetails.diligenceStatus">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>On-Going Due Diligence</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Last Review:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails
                                                        .diligenceStatus
                                                        .lastReview
                                                "
                                                >{{
                                                    customerDetails
                                                        .diligenceStatus
                                                        .lastReview
                                                        | moment('D MMM, YYYY')
                                                }}</span
                                            >
                                            <span
                                                v-if="
                                                    !customerDetails
                                                        .diligenceStatus
                                                        .lastReview
                                                "
                                                >N/A</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Next Review:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="danger">{{
                                                customerDetails.diligenceStatus
                                                    .nextReview
                                                    | moment('D MMM, YYYY')
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <!--<div class="col-md-6">-->
                                <!--<ul class="row">-->
                                <!--<li class="col-md-6">-->
                                <!--<label>Expiry Date:</label>-->
                                <!--</li>-->
                                <!--<li class="col-md-6">-->
                                <!--<span-->
                                <!--:class="-->
                                <!--addDangerClass(-->
                                <!--customerDetails-->
                                <!--.diligenceStatus-->
                                <!--.expiryDate-->
                                <!--)-->
                                <!--"-->
                                <!--&gt;{{-->
                                <!--customerDetails-->
                                <!--.diligenceStatus-->
                                <!--.expiryDate-->
                                <!--| moment('D MMM, YYYY')-->
                                <!--}}</span-->
                                <!--&gt;-->
                                <!--</li>-->
                                <!--</ul>-->
                                <!--</div>-->
                            </div>
                        </div>
                    </li>
                </ul>
                <ul
                    v-if="
                        customerDetails.customInfo &&
                        Object.keys(customerDetails.customInfo).length
                    "
                >
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Additional Information</h3>
                                </div>
                                <div
                                    v-for="(
                                        info, index
                                    ) in customerDetails.customInfo"
                                    :key="index"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ info.title }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="info.type == 'text-field'"
                                                >{{ info.value }}</span
                                            >
                                            <span
                                                v-if="info.type == 'text-area'"
                                                >{{ info.value }}</span
                                            >
                                            <span
                                                v-if="
                                                    info.type ==
                                                        'date-picker' &&
                                                    !!info.value
                                                "
                                                >{{
                                                    info.value
                                                        | moment('D MMM, YYYY')
                                                }}</span
                                            >
                                            <span
                                                v-if="
                                                    info.type ==
                                                        'date-picker' &&
                                                    !info.value
                                                "
                                                >N/A</span
                                            >
                                            <span
                                                v-if="info.type == 'dropdown'"
                                                >{{ info.value }}</span
                                            >
                                            <span v-if="info.type == 'radio'">{{
                                                info.value
                                            }}</span>
                                            <span
                                                v-if="
                                                    info.type == 'checkbox' &&
                                                    info.value
                                                "
                                                >{{
                                                    info.value.join(', ')
                                                }}</span
                                            >
                                            <span
                                                v-if="
                                                    info.type == 'checkbox' &&
                                                    !info.value
                                                "
                                            >
                                                N/A
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-if="customerDetails.signature && customerDetails.signature.sign">
                    <li>
                        <div class="seprator-section">
                            <div class="row ">
                                <div class="col-md-12">
                                    <h3>Signature Panel</h3>
                                </div>
                                <!--<div class="col-md-6"></div>-->
                               <div class="col-md-6 signature-container">
                                   <div class="row">
                                       <div class="col-md-6">
                                           <ul>
                                               <li>
                                                   <label>Signature:</label>
                                                   <img :src="customerDetails.signature.sign">
                                               </li>
                                           </ul>

                                       </div>
                                       <div class="col-md-6">
                                           <ul class="row">
                                               <li class="col-md-6">
                                                   <label>Name:</label>
                                               </li>
                                               <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.signature
                                                    .name

                                            }}</span>
                                               </li>
                                           </ul>
                                           <ul class="row">
                                               <li class="col-md-6">
                                                   <label>Position:</label>
                                               </li>
                                               <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.signature
                                                    .position

                                            }}</span>
                                               </li>
                                           </ul>
                                           <ul class="row">
                                               <li class="col-md-6">
                                                   <label>Date:</label>
                                               </li>
                                               <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.signature
                                                    .date | moment('D MMM, YYYY')

                                            }}</span>
                                               </li>
                                           </ul>
                                       </div>
                                   </div>
                               </div>
                            </div>
                        </div>
                    </li>
                </ul>

            </div>
        </div>

        <export-or-send-popup
            @setSendEmail="setSendEmail"
            @startDownload="() => startDownload()"
        ></export-or-send-popup>

        <custom-popup v-if="customerDetails.ipLocationDetails && customerDetails.ipLocationDetails.ip"
            popupId="ip-popup" size="lg" title="IP Details"
            :content="`<iframe style='width:100%; height: 550px;' src='https://whatismyipaddress.com/ip/${customerDetails.ipLocationDetails.ip}' />`"
            okMessage="Close"
        ></custom-popup>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapGetters } from 'vuex'
import ExportOrSendPopup from './popups/ExportOrSendPopup.vue'
import CustomPopup from './popups/CustomPopup.vue'
import _ from "lodash";

export default {
    // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > filters
    |--------------------------------------------------------------------------
    */
    components: {
        ExportOrSendPopup,
        CustomPopup,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        customerDetails: {
            type: Object,
            default: null,
        },
        showDownloadModal: {
            type: Boolean,
            default: false,
        },
        additionalInfo:{
            type: Boolean,
            default: false,
        }
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            APP_URL: process.env.VUE_APP_API_URL,
            country: process.env.VUE_APP_COUNTRY,
            tempCountry : process.env.VUE_APP_COUNTRY_TEMP,
            // Modal Data
            sendEmail: false,
            // Modal Data End
            associatedIndividualTypes: {
                companyShareholders: 'Company Shareholders',
                authorisedPersons: 'Authorised Persons',
                companyDirectors: 'Company Directors',
                companyExecutiveManagement: 'Company Executive Management',
                companyUltimateBeneficialOwner: 'Company Ultimate Beneficial Owner',
            },
            associatedShareHolderFields: {
                name: {
                    label: 'Name',
                    tdAttr: { dataname: 'name', },
                    thStyle: { width: "10%" },
                },
                entityType: {
                    label: 'Entity Type',
                    tdAttr: { dataname: 'entityType', },
                    thStyle: { width: "10%" },
                },
                dob: {
                    label: 'Date of Birth/Incorporation',
                    tdAttr: { dataname: 'dob', },
                    thStyle: { width: "15%" },
                },
                dateOfAppointment: {
                    label: 'Date of Appointment',
                    tdAttr: { dataname: 'dateOfAppointment', },
                    thStyle: { width: "15%" },
                },
                dateOfTermination: {
                    label: 'Date of Termination',
                    tdAttr: { dataname: 'dateOfTermination', },
                    thStyle: { width: "15%" },
                },
                shares: {
                    label: '% of Shares Held',
                    tdAttr: { dataname: 'shares', },
                    thStyle: { width: "5%" },
                },
                countryOfResidence: {
                    label: 'Country of Residence/Domicile',
                    tdAttr: { dataname: 'countryOfResidence', },
                    thStyle: { width: "10%" },
                },
                nationality: {
                    label: 'Nationality',
                    tdAttr: { dataname: 'nationality', },
                    thStyle: { width: "15%" },
                },
                idNumber: {
                    label: 'National Id Number',
                    tdAttr: { dataname: 'idNumber', },
                    thStyle: { width: "10%" },
                },
                idExpiry: {
                    label: 'National Id Expiry',
                    tdAttr: { dataname: 'idExpiry', },
                    thStyle: { width: "10%" },
                },
                passportNumber: {
                    label: 'Passport Number',
                    tdAttr: { dataname: 'passportNumber', },
                    thStyle: { width: "10%" },
                },
                passportExpiry: {
                    label: 'Passport Expiry',
                    tdAttr: { dataname: 'passportExpiry', },
                    thStyle: { width: "10%" },
                },
                status: {
                    label: 'Status',
                    tdAttr: { dataname: 'status', },
                    thStyle: { width: "15%" },
                },
                riskRating: {
                    label: 'Risk Rating',
                    tdAttr: { dataname: 'riskRating', },
                    thStyle: { width: "15%" },
                },
            },
            associatedIndividualFields: {
                name: {
                    label: 'Name',
                    tdAttr: { dataname: 'name'},
                    thStyle: { width: "15%" },
                },
                dob: {
                    label: 'Date of Birth',
                    tdAttr: { dataname: 'dob', },
                    thStyle: { width: "15%" },
                },
                dateOfAppointment: {
                    label: 'Date of Appointment',
                    tdAttr: { dataname: 'dateOfAppointment', },
                    thStyle: { width: "15%" },
                },
                dateOfTermination: {
                    label: 'Date of Termination',
                    tdAttr: { dataname: 'dateOfTermination', },
                    thStyle: { width: "15%" },
                },
                countryOfResidence: {
                    label: 'Country of Residence',
                    tdAttr: { dataname: 'countryOfResidence', },
                    thStyle: { width: "15%" },
                },
                nationality: {
                    label: 'Nationality',
                    tdAttr: { dataname: 'nationality', },
                    thStyle: { width: "15%" },
                },
                idNumber: {
                    label: 'National Id Number',
                    tdAttr: { dataname: 'idNumber', },
                    thStyle: { width: "10%" },
                },
                idExpiry: {
                    label: 'National Id Expiry',
                    tdAttr: { dataname: 'idExpiry', },
                    thStyle: { width: "10%" },
                },
                passportNumber: {
                    label: 'Passport Number',
                    tdAttr: { dataname: 'passportNumber', },
                    thStyle: { width: "10%" },
                },
                passportExpiry: {
                    label: 'Passport Expiry',
                    tdAttr: { dataname: 'passportExpiry', },
                    thStyle: { width: "10%" },
                },
                status: {
                    label: 'Status',
                    tdAttr: { dataname: 'status', },
                    thStyle: { width: "10%" },

                },
                riskRating: {
                    label: 'Risk Rating',
                    tdAttr: { dataname: 'riskRating', },
                    thStyle: { width: "10%" },

                },
            },
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        fullName() {
            return (
                this.customerDetails.firstName 
                // ' ' +
                // this.customerDetails.middleName +
                // ' ' +
                // this.customerDetails.lastName
            )
        },
        ...mapGetters(['loading','hasScopes','dataSegmentConfigurations']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        if(this.customerDetails && this.customerDetails.status == "archived") {
            return this.$router.push({ name: 'view-customer-profile' })
        }
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
   watch: {
    customerDetails(value){
        if(value && value.status == "archived") {
            return this.$router.push({ name: 'view-customer-profile' })
        }
    }
   },
    methods: {
      checkConfig(){
        if (!_.isEmpty(this.dataSegmentConfigurations) && this.dataSegmentConfigurations.emailProfile && this.dataSegmentConfigurations.emailProfile.status) {
          this.showPopup('export-or-send-popup')
        }
        else
        {
          this.startDownload();
        }
      },
        redirectToIndividual(item){
            const link = item.entityType == 'company' ?
                `/company-profiles/customer-information/${item.customerId}` :
                `/customer-profiles/customer-information/${item.customerId}`
            this.$router.push(link)
            
        },
        checkState(arr) {
            if (Array.isArray(arr)) {
                return arr[0].title
            }
            return arr
        },
        addDangerClass(date) {
            let expiryDate = this.$moment(date)
            let diff = expiryDate.diff(this.$moment(), 'days')
            if (diff <=30) {
                return 'danger'
            }
            return ''
        },
        startDownloadOld() {

            this.$store.commit('setLoading', true)

            let searchParams = {
                timezoneOffset: (new Date()).getTimezoneOffset(),
            }
            if (this.sendEmail) {
                searchParams['sendEmail'] = true;
            }
            axios({
                method: 'get',
                url: `${process.env.VUE_APP_API_URL}customers/generateReport/${this.customerDetails._id}`,
                params: searchParams,
            })
                .then((response) => {
                    if (this.sendEmail) {
                        this.$store.commit('setLoading', false)
                        this.$store.commit('setLoading', false)
                        this.$store.commit(
                            'setSuccess',
                            'Customer Profile has been sent on your email'
                        )

                        return
                    }
                    // else

                    axios({
                        method: 'get',
                        url: `${process.env.VUE_APP_API_URL}files/reports-individual/${response.data.data.fileName}`,
                        responseType: 'blob',
                    }).then((response) => {
                        this.forceFileDownload(response)
                        this.$store.commit('setLoading', false)
                    })
                })
                .catch(() => console.log('error occured'))
        },
        startDownload() {

            this.$store.commit('setLoading', true)

            let searchParams = {
                timezoneOffset: (new Date()).getTimezoneOffset(),
            }
            if (this.sendEmail) {
                searchParams['sendEmail'] = true;
            }
            axios({
                method: 'get',
                url: `${process.env.VUE_APP_API_URL}customers/generateReport/${this.customerDetails._id}`,
                params: searchParams,
                responseType: 'blob',
            })
                .then((response) => {
                    if (this.sendEmail) {
                        this.$store.commit('setLoading', false)
                        this.$store.commit(
                            'setSuccess',
                            'Customer Profile has been sent on your email'
                        )

                        return
                    }
                    // if(response && response.data && response.data.status)
                    // {
                    //     this.downloadFile(response.data.data)
                    // }
                    if(response && response.data)
                    {
                        if(response.data.status && response.data.status==false)
                        {
                            this.$store.commit('setLoading', false)
                            this.$store.commit('setError', 'Error in downloading report.')
                            return
                        }
                        this.downloadFile(response)
                    }
                })
                .catch((e) =>
                    {
                        this.$store.commit('setLoading', false)
                        this.$store.commit('setError', 'Something went wrong, please try again later!')
                        console.log('error occurred',e)

                    })
        },
        downloadFile(response){
            let fileName = 'Customer-Summary.pdf';
            if (this.customerDetails && this.customerDetails.firstName && this.customerDetails.idenfoId) {
                fileName=this.customerDetails.idenfoId+'-'+this.customerDetails.firstName+'.pdf'
            }
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            this.$store.commit('setLoading', false)

        },
        downloadFileOld(data) {

            // Convert the Base64 string back to binary data
            const byteCharacters = atob(data.file); // atob() decodes Base64 to binary string
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });

            // Create a temporary download link
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob); // Create a URL for the Blob
            link.download = data.fileName//'summary-report.pdf'; // Specify the file name for download
            document.body.appendChild(link); // Append link to body
            link.click(); // Trigger download
            document.body.removeChild(link); // Clean up the link element
            this.$store.commit('setLoading', false)
        },
        showPopup(id='export-or-send-popup') {
            this.$bvModal.show(id)
        },
        forceFileDownload(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
                'download',
                `${this.customerDetails.firstName}-${this.customerDetails.idenfoId}.pdf`
            )
            document.body.appendChild(link)
            link.click()
            // this.$store.commit('setLoading', false)
        },

        setSendEmail(val) {
            this.sendEmail = val
        },
        formatValue(value)
        {
            if(value)
            {
                return value
            }

            return "N/A"
        }
    }, // End of Component > filters
} // End of export default
</script>
<style>
    .signature-container
    {
        border: 1px solid grey;
        border-radius: 5px;
        padding-top: 10px;
    }
    .associated-individuals-table td div .status-view{
        margin: 10px auto !important;
        position: static;
        width: 110px;
        display: inline-block;
    }
    /* Styling for the table scroller */
    .associated-individuals-table {
    overflow-x: auto; /* Enable horizontal scrolling */
    white-space: nowrap; /* Prevent table cells from wrapping */
    max-width: 100%; /* Ensure the table doesn't exceed its container */
    margin-bottom: 20px; /* Optional: Add some space at the bottom */
    }

    /* Custom styling for the scroll bar */
    .associated-individuals-table::-webkit-scrollbar {
    width: 6px; /* Set the width of the scrollbar */
    height: 8px; /* Set the width of the scrollbar */
    }

    /* Track (the empty space in the scrollbar) */
    .associated-individuals-table::-webkit-scrollbar-track {
    background: #f1f1f1; /* Color of the track */
    }

    /* Handle (the draggable part of the scrollbar) */
    .associated-individuals-table::-webkit-scrollbar-thumb {
    background: #888; /* Color of the handle */
    border-radius: 6px; /* Rounded corners */
    }

    /* Handle on hover */
    .associated-individuals-table::-webkit-scrollbar-thumb:hover {
    background: #555; /* Darker color when hovered */
    }

.uaePassed
{
    color: green;
}
</style>
